import { useAtomValue } from 'jotai';

import { getAnalysisParameterValue, Unit } from '@core';
import { ParameterData } from '@data';
import { useAnalysisById } from '@hooks';
import { useActivityReport } from '@queries';
import { activeAnalysisAtom, corridorsAtom, convertedLayoutCustomCorridorsMapAtom, userSettingsAtom } from '@store';
import { FloorParameterCard } from '@ui';

type ParameterProps = {
    name: string;
    parameter: ParameterData;
};

export const Parameter = ({ name, parameter }: ParameterProps) => {
    const userSettings = useAtomValue(userSettingsAtom);
    const corridors = useAtomValue(corridorsAtom);
    const customCorridorMap = useAtomValue(convertedLayoutCustomCorridorsMapAtom);
    const activeSwingAnalysis = useAtomValue(activeAnalysisAtom);
    const comparisonSwingAnalysis = useAnalysisById(userSettings.comparisonSwingId);
    const { data: activityReport } = useActivityReport();
    const selectedActiveAnalysis = activeSwingAnalysis?.fullAnalysis || activeSwingAnalysis?.quickAnalysis;
    const paramValue = getAnalysisParameterValue(selectedActiveAnalysis, parameter.name);
    const comparisonParamValue = getAnalysisParameterValue(comparisonSwingAnalysis, parameter.name);
    const goalValue = customCorridorMap?.[parameter.smpId];
    const paramCorridors = corridors?.[parameter.name];
    const reportValue = activityReport?.[parameter.name];

    return (
        <FloorParameterCard
            key={parameter.smpId}
            title={name}
            unit={parameter.unit as Unit}
            value={paramValue}
            mean={reportValue?.mean}
            stdDev={reportValue?.stdDev}
            userPreferredUnit={userSettings.userPreferredUnit}
            corridorParameterMargins={userSettings.showCorridors ? paramCorridors : null}
            comparisonValue={userSettings.showComparison ? comparisonParamValue : null}
            goalCorridor={userSettings.showGoal ? goalValue : null}
        />
    );
};
